import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Mail01, Lock01 } from "@untitledui/icons";
import { useAuth } from "@/context/AuthProvider";
import { Input } from "@/components/base/input/input";
import { Button } from "@/components/base/buttons/button";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  if (isAuthenticated) {
    navigate("/dashboard", { replace: true });
    return null;
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      await login(email, password);
      navigate("/dashboard");
    } catch {
      setError("Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg-secondary">
      <div className="w-full max-w-sm">
        <div className="bg-bg-primary border border-border-secondary rounded-xl shadow-lg p-8">
          <h1 className="text-xl font-semibold text-text-primary mb-1">My Garage</h1>
          <p className="text-sm text-text-secondary mb-6">Sign in to your account</p>

          <form onSubmit={handleSubmit} className="space-y-4">
            {error && (
              <div className="p-3 rounded-lg bg-bg-error-primary text-text-error-primary text-sm">
                {error}
              </div>
            )}

            <Input
              label="Email"
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={setEmail}
              icon={Mail01}
              isRequired
            />

            <Input
              label="Password"
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={setPassword}
              icon={Lock01}
              isRequired
            />

            <Button
              type="submit"
              size="md"
              color="primary"
              isLoading={loading}
              isDisabled={loading}
              className="w-full"
            >
              Sign in
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
